document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  let translations = {};
  try {
    translations = JSON.parse(document.querySelector('[data-manila-translations]')?.textContent || '{}');
  } catch (error) {
    translations = {};
  }
  const tr = (key, fallback) => translations[key] || fallback;
  let refreshWishlistButtons = () => {};
  const focusableSelector = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), summary, [tabindex]:not([tabindex="-1"])';
  const trapFocus = (event, container) => {
    if (event.key !== 'Tab') return;
    const focusable = [...container.querySelectorAll(focusableSelector)].filter((element) => !element.hidden && element.offsetParent !== null);
    if (focusable.length === 0) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  };

  const drawer = document.querySelector('[data-menu-drawer]');
  const openButton = document.querySelector('[data-menu-open]');
  const closeButton = document.querySelector('[data-menu-close]');

  const setDrawer = (open) => {
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    openButton?.setAttribute('aria-expanded', open ? 'true' : 'false');
    document.body.classList.toggle('drawer-open', open);
    if (open) drawer.querySelector('a, button, summary')?.focus();
    else openButton?.focus();
  };

  openButton?.addEventListener('click', () => setDrawer(true));
  closeButton?.addEventListener('click', () => setDrawer(false));
  drawer?.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => setDrawer(false)));
  drawer?.addEventListener('keydown', (event) => trapFocus(event, drawer));
  drawer?.querySelectorAll('.manila-drawer__group').forEach((group) => {
    group.addEventListener('toggle', () => {
      if (!group.open) return;
      drawer.querySelectorAll('.manila-drawer__group[open]').forEach((otherGroup) => {
        if (otherGroup !== group) otherGroup.open = false;
      });
    });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && drawer?.getAttribute('aria-hidden') === 'false') setDrawer(false);
  });

  const searchOverlay = document.querySelector('[data-search-overlay]');
  const searchOpeners = document.querySelectorAll('[data-search-open]');
  const searchInput = searchOverlay?.querySelector('[data-predictive-search-input]');
  const searchResults = searchOverlay?.querySelector('[data-predictive-search-results]');
  let predictiveTimer;
  let predictiveRequest;
  let lastSearchOpener;

  const setSearch = (open, opener) => {
    if (!searchOverlay) return;
    if (open && drawer?.getAttribute('aria-hidden') === 'false') setDrawer(false);
    searchOverlay.setAttribute('aria-hidden', open ? 'false' : 'true');
    searchOpeners.forEach((item) => item.setAttribute('aria-expanded', open ? 'true' : 'false'));
    document.body.classList.toggle('search-open', open);
    if (open) {
      lastSearchOpener = opener || document.activeElement;
      window.setTimeout(() => searchInput?.focus(), 30);
    } else {
      searchInput?.setAttribute('aria-expanded', 'false');
      if (lastSearchOpener instanceof HTMLElement) lastSearchOpener.focus();
    }
  };

  searchOpeners.forEach((opener) => {
    opener.setAttribute('aria-expanded', 'false');
    opener.addEventListener('click', (event) => {
      if (!searchOverlay) return;
      event.preventDefault();
      setSearch(true, opener);
    });
  });
  searchOverlay?.querySelectorAll('[data-search-close]').forEach((button) => button.addEventListener('click', () => setSearch(false)));
  searchOverlay?.addEventListener('keydown', (event) => trapFocus(event, searchOverlay));
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && searchOverlay?.getAttribute('aria-hidden') === 'false') setSearch(false);
  });

  const renderPredictiveResults = (products, query) => {
    if (!searchResults || !searchInput) return;
    searchResults.replaceChildren();
    if (products.length === 0) {
      const empty = document.createElement('p');
      empty.className = 'manila-predictive-search__empty';
      empty.textContent = tr('search_empty', 'No se han encontrado productos.');
      searchResults.append(empty);
      searchInput.setAttribute('aria-expanded', 'true');
      return;
    }

    const list = document.createElement('div');
    list.className = 'manila-predictive-search__list';
    list.setAttribute('role', 'listbox');
    products.forEach((product) => {
      const link = document.createElement('a');
      link.className = 'manila-predictive-search__item';
      link.href = product.url;
      link.setAttribute('role', 'option');

      const imageUrl = typeof product.image === 'string' ? product.image : product.image?.url;
      if (imageUrl) {
        const image = document.createElement('img');
        image.src = imageUrl;
        image.width = 72;
        image.height = 92;
        image.loading = 'lazy';
        image.alt = '';
        link.append(image);
      } else {
        const placeholder = document.createElement('span');
        placeholder.className = 'manila-predictive-search__placeholder';
        link.append(placeholder);
      }

      const copy = document.createElement('span');
      const title = document.createElement('strong');
      title.textContent = product.title;
      if (searchOverlay.dataset.showVendor === 'true' && product.vendor) {
        const vendor = document.createElement('small');
        vendor.textContent = product.vendor;
        copy.append(vendor);
      }
      copy.append(title);
      if (product.price !== null && product.price !== undefined) {
        const price = document.createElement('small');
        price.className = 'manila-predictive-search__price';
        try {
          price.textContent = new Intl.NumberFormat(document.documentElement.lang, {
            style: 'currency',
            currency: searchOverlay.dataset.currency
          }).format(Number(product.price));
        } catch (error) {
          price.textContent = String(product.price);
        }
        copy.append(price);
      }
      link.append(copy);
      list.append(link);
    });

    const allResults = document.createElement('a');
    allResults.className = 'manila-predictive-search__all';
    const allResultsUrl = new URL(searchOverlay.dataset.searchUrl, window.location.origin);
    allResultsUrl.searchParams.set('q', query);
    allResultsUrl.searchParams.set('type', 'product');
    allResultsUrl.searchParams.set('options[prefix]', 'last');
    allResults.href = allResultsUrl.toString();
    allResults.textContent = tr('search_all', 'Ver todos los resultados');
    const allResultsArrow = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    allResultsArrow.setAttribute('class', 'manila-icon-arrow manila-icon-arrow--up-right');
    allResultsArrow.setAttribute('viewBox', '0 0 24 24');
    allResultsArrow.setAttribute('aria-hidden', 'true');
    const allResultsArrowPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    allResultsArrowPath.setAttribute('d', 'M5 19 19 5M8 5h11v11');
    allResultsArrow.append(allResultsArrowPath);
    allResults.append(allResultsArrow);
    searchResults.append(list, allResults);
    searchInput.setAttribute('aria-expanded', 'true');
  };

  searchInput?.addEventListener('input', () => {
    window.clearTimeout(predictiveTimer);
    predictiveRequest?.abort();
    const query = searchInput.value.trim();
    if (!searchResults || query.length < 2) {
      searchResults?.replaceChildren();
      searchResults?.setAttribute('aria-busy', 'false');
      searchInput.setAttribute('aria-expanded', 'false');
      return;
    }

    predictiveTimer = window.setTimeout(async () => {
      try {
        searchResults.setAttribute('aria-busy', 'true');
        predictiveRequest = new AbortController();
        const endpoint = new URL(searchOverlay.dataset.predictiveSearchUrl, window.location.origin);
        endpoint.searchParams.set('q', query);
        endpoint.searchParams.set('resources[type]', 'product');
        endpoint.searchParams.set('resources[limit]', '6');
        endpoint.searchParams.set('resources[options][unavailable_products]', 'last');
        const response = await fetch(endpoint, { signal: predictiveRequest.signal, headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error('Predictive search request failed');
        const payload = await response.json();
        renderPredictiveResults(payload.resources?.results?.products || [], query);
      } catch (error) {
        if (error.name !== 'AbortError') searchInput.setAttribute('aria-expanded', 'false');
      } finally {
        searchResults.setAttribute('aria-busy', 'false');
      }
    }, 220);
  });
  searchInput?.addEventListener('keydown', (event) => {
    if (event.key !== 'ArrowDown') return;
    const firstResult = searchResults?.querySelector('.manila-predictive-search__item');
    if (firstResult) {
      event.preventDefault();
      firstResult.focus();
    }
  });
  searchResults?.addEventListener('keydown', (event) => {
    if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;
    const resultLinks = [...searchResults.querySelectorAll('.manila-predictive-search__item')];
    const index = resultLinks.indexOf(document.activeElement);
    if (index < 0) return;
    event.preventDefault();
    const targetIndex = event.key === 'ArrowDown'
      ? Math.min(index + 1, resultLinks.length - 1)
      : Math.max(index - 1, 0);
    resultLinks[targetIndex]?.focus();
  });

  document.querySelectorAll('[data-sort-by]').forEach((select) => {
    select.addEventListener('change', (event) => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', event.target.value);
      window.location.assign(url.toString());
    });
  });

  document.querySelectorAll('[data-filters-toggle]').forEach((toggle) => {
    const panel = document.getElementById(toggle.getAttribute('aria-controls'));
    if (!panel) return;
    const closeButtons = [
      ...panel.querySelectorAll('[data-filters-close]'),
      ...document.querySelectorAll(`[data-filters-backdrop][aria-controls="${panel.id}"]`)
    ];

    const setFiltersPanel = (open) => {
      panel.setAttribute('aria-hidden', open ? 'false' : 'true');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.classList.toggle('facets-open', open);
      if (open) panel.querySelector('summary, input, button')?.focus();
      else toggle.focus();
    };

    toggle.addEventListener('click', () => setFiltersPanel(toggle.getAttribute('aria-expanded') !== 'true'));
    closeButtons.forEach((button) => button.addEventListener('click', () => setFiltersPanel(false)));
    panel.addEventListener('keydown', (event) => {
      if (window.matchMedia('(max-width: 900px)').matches) trapFocus(event, panel);
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && panel.getAttribute('aria-hidden') === 'false') setFiltersPanel(false);
    });
  });

  document.querySelectorAll('[data-filter-search]').forEach((input) => {
    const values = input.closest('.manila-facet__content')?.querySelector('[data-filter-values]');
    if (!values) return;
    const options = [...values.querySelectorAll('[data-filter-value]')];
    const emptyState = values.querySelector('[data-filter-empty]');

    input.addEventListener('keydown', (event) => {
      if (event.key === 'Enter') event.preventDefault();
    });
    input.addEventListener('input', () => {
      const query = input.value.trim().toLocaleLowerCase();
      let visibleOptions = 0;
      options.forEach((option) => {
        const visible = option.dataset.filterLabel.includes(query);
        option.hidden = !visible;
        if (visible) visibleOptions += 1;
      });
      if (emptyState) emptyState.hidden = visibleOptions > 0;
    });
  });

  const initializeProductCard = (card) => {
    if (card.dataset.cardInitialized === 'true') return;
    card.dataset.cardInitialized = 'true';
    const image = card.querySelector('[data-card-image]');
    const secondaryImage = card.querySelector('[data-card-secondary-image]');
    const productLinks = card.querySelectorAll('.manila-product-card__image, .manila-product-card__title');
    const swatches = card.querySelectorAll('[data-card-swatch]');
    let selectedSwatch = card.querySelector('[data-card-swatch].is-selected');

    const hydrateSecondaryImage = () => {
      if (!secondaryImage || secondaryImage.src || !secondaryImage.dataset.cardSecondarySrc) return;
      secondaryImage.addEventListener('load', () => {
        secondaryImage.hidden = false;
        secondaryImage.classList.add('is-loaded');
      }, { once: true });
      secondaryImage.src = secondaryImage.dataset.cardSecondarySrc;
    };

    const previewSwatch = (swatch, select = false, temporary = false) => {
      if (swatch.disabled) return;
      card.classList.toggle('is-swatch-preview', temporary);
      if (swatch.dataset.imageSrc && image) {
        image.src = swatch.dataset.imageSrc;
        image.removeAttribute('srcset');
      }
      if (select) {
        swatches.forEach((item) => {
          const selected = item === swatch;
          item.classList.toggle('is-selected', selected);
          item.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });
        selectedSwatch = swatch;
        if (swatch.dataset.variantUrl) productLinks.forEach((link) => { link.href = swatch.dataset.variantUrl; });
      }
    };

    card.addEventListener('pointerenter', hydrateSecondaryImage, { once: true });
    card.addEventListener('focusin', hydrateSecondaryImage, { once: true });
    card.addEventListener('pointerleave', () => {
      card.classList.remove('is-swatch-preview');
      if (selectedSwatch) previewSwatch(selectedSwatch);
    });
    swatches.forEach((swatch) => {
      swatch.addEventListener('pointerenter', () => previewSwatch(swatch, false, true));
      swatch.addEventListener('pointerleave', () => {
        card.classList.remove('is-swatch-preview');
        if (selectedSwatch) previewSwatch(selectedSwatch);
      });
      swatch.addEventListener('click', () => previewSwatch(swatch, true));
    });
  };

  document.querySelectorAll('[data-product-card]').forEach(initializeProductCard);

  const initializeProductRail = (rail) => {
    if (rail.dataset.railInitialized === 'true') return;
    rail.dataset.railInitialized = 'true';
    const track = rail.querySelector('[data-product-rail-track]');
    const previous = rail.querySelector('[data-rail-previous]');
    const next = rail.querySelector('[data-rail-next]');
    if (!track) return;

    const scrollAmount = () => {
      const firstCard = track.firstElementChild;
      if (!firstCard) return track.clientWidth;
      const styles = window.getComputedStyle(track);
      return firstCard.getBoundingClientRect().width + Number.parseFloat(styles.columnGap || styles.gap || 0);
    };
    const update = () => {
      if (previous) previous.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    };

    previous?.addEventListener('click', () => track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' }));
    next?.addEventListener('click', () => track.scrollBy({ left: scrollAmount(), behavior: 'smooth' }));
    let railFrame;
    track.addEventListener('scroll', () => {
      window.cancelAnimationFrame(railFrame);
      railFrame = window.requestAnimationFrame(update);
    }, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  };

  document.querySelectorAll('[data-product-rail]').forEach(initializeProductRail);

  const normalizeVendor = (value) => String(value || '').trim().toLocaleLowerCase();

  const fillVendorRecommendations = async (container) => {
    const vendor = container.dataset.vendor?.trim();
    const vendorSearchUrl = container.dataset.vendorSearchUrl;
    const currentProductId = String(container.dataset.currentProductId || '');
    const productsLimit = Math.max(1, Number.parseInt(container.dataset.productsLimit || '8', 10));
    const rail = container.querySelector('[data-product-rail]');
    const track = container.querySelector('[data-product-rail-track]');
    if (!vendor || !vendorSearchUrl || !rail || !track) return;

    const existingCards = [...track.querySelectorAll('[data-product-card]')];
    const productIds = new Set(existingCards.map((card) => String(card.dataset.productId || '')));

    if (existingCards.length < productsLimit) {
      try {
        const endpoint = new URL(vendorSearchUrl, window.location.origin);
        endpoint.searchParams.set('view', 'vendor-recommendations');
        endpoint.searchParams.set('q', vendor);
        endpoint.searchParams.set('type', 'product');
        endpoint.searchParams.set('options[prefix]', 'none');
        const response = await fetch(endpoint, { headers: { Accept: 'text/html' } });
        if (!response.ok) throw new Error('Vendor search request failed');
        const html = await response.text();
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const candidates = parsed.querySelectorAll('[data-vendor-search-results] [data-product-card]');

        for (const candidate of candidates) {
          const candidateId = String(candidate.dataset.productId || '');
          const candidateVendor = candidate.querySelector('.manila-product-card__vendor')?.textContent;
          if (
            !candidateId
            || candidateId === currentProductId
            || productIds.has(candidateId)
            || normalizeVendor(candidateVendor) !== normalizeVendor(vendor)
          ) continue;

          track.append(candidate);
          productIds.add(candidateId);
          if (track.querySelectorAll('[data-product-card]').length >= productsLimit) break;
        }
      } catch (error) {
        // Keep any native Shopify recommendations already available.
      }
    }

    const finalCards = [...track.querySelectorAll('[data-product-card]')].slice(0, productsLimit);
    [...track.querySelectorAll('[data-product-card]')].slice(productsLimit).forEach((card) => card.remove());
    rail.hidden = finalCards.length === 0;
    const controls = rail.querySelector('.manila-product-rail__controls');
    if (controls) controls.hidden = finalCards.length <= 1;
    finalCards.forEach(initializeProductCard);
    initializeProductRail(rail);
    track.dispatchEvent(new Event('scroll'));
    refreshWishlistButtons();
  };

  document.querySelectorAll('[data-product-recommendations]').forEach(async (container) => {
    if (container.dataset.url) {
      try {
        const response = await fetch(container.dataset.url);
        if (response.ok) {
          const html = await response.text();
          const parsed = new DOMParser().parseFromString(html, 'text/html');
          const recommendations = parsed.querySelector('[data-product-recommendations]');
          if (recommendations?.innerHTML.trim()) container.innerHTML = recommendations.innerHTML;
        }
      } catch (error) {
        // The vendor fallback below can still complete the rail.
      }
    }
    await fillVendorRecommendations(container);
  });

  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const root = gallery.closest('[data-product-root]');
    const previous = root?.querySelector('[data-gallery-previous]');
    const next = root?.querySelector('[data-gallery-next]');
    const current = root?.querySelector('[data-gallery-current]');
    if (!previous || !next || !current) return;

    const items = () => [...gallery.querySelectorAll('.manila-product__media')];
    const currentIndex = () => {
      const media = items();
      return media.reduce((nearest, item, index) => (
        Math.abs(item.offsetLeft - gallery.scrollLeft) < Math.abs(media[nearest].offsetLeft - gallery.scrollLeft) ? index : nearest
      ), 0);
    };
    const updateGallery = () => {
      const index = currentIndex();
      current.textContent = String(index + 1);
      previous.disabled = index === 0;
      next.disabled = index === items().length - 1;
    };
    const moveGallery = (direction) => {
      const media = items();
      const targetIndex = Math.min(Math.max(currentIndex() + direction, 0), media.length - 1);
      gallery.scrollTo({ left: media[targetIndex].offsetLeft, behavior: 'smooth' });
    };

    previous.addEventListener('click', () => moveGallery(-1));
    next.addEventListener('click', () => moveGallery(1));
    let galleryFrame;
    gallery.addEventListener('scroll', () => {
      window.cancelAnimationFrame(galleryFrame);
      galleryFrame = window.requestAnimationFrame(updateGallery);
    }, { passive: true });
    updateGallery();
  });

  document.querySelectorAll('[data-product-zoom]').forEach((dialog) => {
    const productRoot = document.querySelector('[data-product-root]');
    const triggers = [...productRoot?.querySelectorAll('[data-product-zoom-open]') || []];
    const zoomImage = dialog.querySelector('[data-product-zoom-image]');
    const counter = dialog.querySelector('[data-zoom-current]');
    const previous = dialog.querySelector('[data-zoom-previous]');
    const next = dialog.querySelector('[data-zoom-next]');
    let zoomIndex = 0;
    let returnFocus;

    const renderZoom = () => {
      const trigger = triggers[zoomIndex];
      if (!trigger || !zoomImage) return;
      zoomImage.src = trigger.dataset.zoomSrc;
      zoomImage.alt = trigger.dataset.zoomAlt || '';
      if (counter) counter.textContent = String(zoomIndex + 1);
    };
    const closeZoom = () => {
      if (typeof dialog.close === 'function') dialog.close();
      else dialog.removeAttribute('open');
    };

    triggers.forEach((trigger, index) => {
      trigger.addEventListener('click', () => {
        zoomIndex = index;
        returnFocus = trigger;
        renderZoom();
        if (typeof dialog.showModal === 'function') dialog.showModal();
        else dialog.setAttribute('open', '');
        document.body.classList.add('zoom-open');
      });
    });
    previous?.addEventListener('click', () => {
      zoomIndex = (zoomIndex - 1 + triggers.length) % triggers.length;
      renderZoom();
    });
    next?.addEventListener('click', () => {
      zoomIndex = (zoomIndex + 1) % triggers.length;
      renderZoom();
    });
    dialog.querySelector('[data-product-zoom-close]')?.addEventListener('click', closeZoom);
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) closeZoom();
    });
    dialog.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') previous?.click();
      if (event.key === 'ArrowRight') next?.click();
      trapFocus(event, dialog);
    });
    dialog.addEventListener('close', () => {
      document.body.classList.remove('zoom-open');
      returnFocus?.focus();
    });
  });

  document.querySelectorAll('[data-product-root]').forEach((productRoot) => {
    const select = productRoot.querySelector('[data-product-variant-select]');
    const variantsScript = productRoot.querySelector('[data-product-variants]');
    const groups = [...productRoot.querySelectorAll('[data-product-option]')];
    if (!select || !variantsScript || groups.length === 0) return;

    let variants = [];
    try { variants = JSON.parse(variantsScript.textContent); } catch (error) { return; }

    let selectedOptions = groups.map((group) => {
      const selected = group.querySelector('[data-option-value].is-selected');
      const dropdown = group.querySelector('[data-option-select]');
      return selected?.dataset.optionValue || dropdown?.value || group.querySelector('[data-option-value]')?.dataset.optionValue;
    });

    const optionForVariant = (variant) => select.querySelector(`option[value="${variant.id}"]`);

    const renderVariant = (variant, moveMedia = false) => {
      if (!variant) return;
      const variantOption = optionForVariant(variant);
      select.value = String(variant.id);

      const price = productRoot.querySelector('[data-product-price]');
      const comparePrice = productRoot.querySelector('[data-product-compare-price]');
      const addButton = productRoot.querySelector('[data-add-to-cart]');
      const variantStatus = productRoot.querySelector('[data-variant-status]');
      if (price && variantOption?.dataset.price) price.textContent = variantOption.dataset.price;
      if (comparePrice) {
        comparePrice.textContent = variantOption?.dataset.comparePrice || '';
        comparePrice.hidden = !variantOption?.dataset.comparePrice;
      }
      if (addButton) {
        addButton.disabled = !variant.available;
        addButton.textContent = variant.available
          ? `${tr('add_to_bag', 'Añadir a la bolsa')} — ${variantOption?.dataset.priceButton || ''}`
          : tr('sold_out', 'Agotado');
      }
      if (variantStatus) variantStatus.textContent = variant.available
        ? tr('variant_available', 'Variante disponible')
        : tr('variant_sold_out', 'Variante agotada');

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());

      if (moveMedia && variant.featured_media?.id) {
        const gallery = productRoot.querySelector('[data-product-gallery]');
        const media = gallery?.querySelector(`[data-media-id="${variant.featured_media.id}"]`);
        if (gallery && media && gallery.firstElementChild !== media) gallery.prepend(media);
        if (gallery && productRoot.classList.contains('manila-product--gallery-slider')) {
          gallery.scrollTo({ left: 0, behavior: 'smooth' });
        }
      }

      select.dispatchEvent(new Event('change', { bubbles: true }));
    };

    const optionIsPossible = (groupIndex, value) => variants.some((variant) => {
      if (!variant.available || variant.options[groupIndex] !== value) return false;
      return variant.options.slice(0, groupIndex).every((optionValue, index) => optionValue === selectedOptions[index]);
    });

    const renderOptions = () => {
      groups.forEach((group, groupIndex) => {
        const label = group.querySelector('[data-selected-option-value]');
        if (label) label.textContent = selectedOptions[groupIndex] || '';

        const dropdown = group.querySelector('[data-option-select]');
        if (dropdown) {
          [...dropdown.options].forEach((option) => {
            option.disabled = !optionIsPossible(groupIndex, option.value);
          });
          dropdown.value = selectedOptions[groupIndex] || dropdown.value;
        }

        group.querySelectorAll('[data-option-value]').forEach((button) => {
          const value = button.dataset.optionValue;
          const possible = optionIsPossible(groupIndex, value);
          const selected = value === selectedOptions[groupIndex];
          button.disabled = !possible;
          button.classList.toggle('is-unavailable', !possible);
          button.classList.toggle('is-selected', selected);
          button.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });
      });
    };

    const chooseOption = (groupIndex, value) => {
      selectedOptions[groupIndex] = value;
      let variant = variants.find((item) => item.options.every((optionValue, index) => optionValue === selectedOptions[index]));

      if (!variant?.available) {
        const fallback = variants.find((item) => {
          if (!item.available) return false;
          return item.options.slice(0, groupIndex + 1).every((optionValue, index) => optionValue === selectedOptions[index]);
        });
        if (fallback) {
          variant = fallback;
          selectedOptions = [...fallback.options];
        }
      }

      renderOptions();
      renderVariant(variant, true);
    };

    groups.forEach((group, groupIndex) => {
      group.querySelectorAll('[data-option-value]').forEach((button) => {
        button.addEventListener('click', () => {
          if (!button.disabled) chooseOption(groupIndex, button.dataset.optionValue);
        });
      });
      group.querySelector('[data-option-select]')?.addEventListener('change', (event) => {
        chooseOption(groupIndex, event.currentTarget.value);
      });
    });

    renderOptions();
    const initialVariant = variants.find((variant) => String(variant.id) === select.value) || variants.find((variant) => variant.available);
    if (initialVariant) {
      selectedOptions = [...initialVariant.options];
      renderOptions();
      renderVariant(initialVariant);
    }
  });

  const cartToast = document.querySelector('[data-cart-toast]');
  let cartToastTimer;
  const showCartMessage = (message, isError = false) => {
    if (!cartToast) return;
    window.clearTimeout(cartToastTimer);
    cartToast.textContent = message;
    cartToast.classList.toggle('is-error', isError);
    cartToast.setAttribute('aria-hidden', 'false');
    cartToastTimer = window.setTimeout(() => cartToast.setAttribute('aria-hidden', 'true'), 2800);
  };

  const updateCartCount = async () => {
    const cartUrl = document.body.dataset.cartJsonUrl;
    if (!cartUrl) return;
    const response = await fetch(cartUrl, { headers: { Accept: 'application/json' } });
    if (!response.ok) return;
    const cartData = await response.json();
    document.querySelectorAll('[data-cart-count]').forEach((count) => { count.textContent = String(cartData.item_count); });
  };

  const quickAddSheet = document.querySelector('[data-quick-add-sheet]');
  const quickAddContent = quickAddSheet?.querySelector('[data-quick-add-content]');
  const quickAddCache = new Map();
  let quickAddReturnFocus;
  let quickAddFromCart = false;

  const setSheet = (sheet, open, returnFocus) => {
    if (!sheet) return;
    sheet.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.body.classList.toggle('sheet-open', open);
    if (open) window.setTimeout(() => sheet.querySelector('.manila-sheet__panel')?.focus(), 30);
    else if (returnFocus instanceof HTMLElement) returnFocus.focus();
  };

  const closeQuickAdd = () => setSheet(quickAddSheet, false, quickAddReturnFocus);
  quickAddSheet?.querySelectorAll('[data-quick-add-close]').forEach((button) => button.addEventListener('click', closeQuickAdd));
  quickAddSheet?.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeQuickAdd();
    trapFocus(event, quickAddSheet);
  });

  const formatMoney = (cents) => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang, {
        style: 'currency',
        currency: document.documentElement.dataset.currency || 'EUR'
      }).format(Number(cents) / 100);
    } catch (error) {
      return `${(Number(cents) / 100).toFixed(2)} €`;
    }
  };

  const renderQuickAdd = (productData, trigger) => {
    if (!quickAddContent) return;
    quickAddContent.replaceChildren();
    const availableVariants = productData.variants.filter((variant) => variant.available);
    if (availableVariants.length === 0) {
      const unavailable = document.createElement('p');
      unavailable.className = 'manila-quick-add__error';
      unavailable.textContent = tr('product_sold_out', 'Este producto está agotado.');
      quickAddContent.append(unavailable);
      return;
    }

    const vendor = document.createElement('p');
    vendor.className = 'manila-quick-add__vendor';
    vendor.textContent = trigger.dataset.productVendor || productData.vendor || '';
    const title = document.createElement('h2');
    title.className = 'manila-quick-add__title';
    title.textContent = trigger.dataset.productTitle || productData.title;
    quickAddContent.append(vendor, title);

    const variants = productData.variants;
    let selectedOptions = [...availableVariants[0].options];
    const optionGroups = [];
    const optionDefinitions = (productData.options || []).map((option, index) => {
      if (typeof option === 'string') {
        return { name: option, values: [...new Set(variants.map((variant) => variant.options[index]))] };
      }
      return {
        name: option.name || `${tr('option', 'Opción')} ${index + 1}`,
        values: option.values || [...new Set(variants.map((variant) => variant.options[index]))]
      };
    });

    optionDefinitions.forEach((option, optionIndex) => {
      const fieldset = document.createElement('fieldset');
      fieldset.className = 'manila-quick-add__option';
      const legend = document.createElement('legend');
      legend.textContent = /talla|size|taille|taglia/i.test(option.name) ? 'Talla' : option.name;
      const values = document.createElement('div');
      values.className = 'manila-quick-add__values';
      const buttons = option.values.map((value) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.textContent = value;
        button.dataset.optionValue = value;
        button.addEventListener('click', () => {
          selectedOptions[optionIndex] = value;
          let variant = variants.find((item) => item.available && item.options.every((optionValue, index) => optionValue === selectedOptions[index]));
          if (!variant) {
            variant = variants.find((item) => item.available
              && item.options[optionIndex] === value
              && item.options.slice(0, optionIndex).every((optionValue, index) => optionValue === selectedOptions[index]));
          }
          if (variant) selectedOptions = [...variant.options];
          updateQuickAdd();
        });
        values.append(button);
        return button;
      });
      optionGroups.push(buttons);
      fieldset.append(legend, values);
      quickAddContent.append(fieldset);
    });

    const form = document.createElement('form');
    form.className = 'manila-quick-add__form';
    form.method = 'post';
    form.action = document.body.dataset.cartAddUrl || '/cart/add';
    const variantInput = document.createElement('input');
    variantInput.type = 'hidden';
    variantInput.name = 'id';
    const addButton = document.createElement('button');
    addButton.className = 'manila-quick-add__submit';
    addButton.type = 'submit';
    addButton.name = 'add';
    form.append(variantInput, addButton);
    quickAddContent.append(form);

    function updateQuickAdd() {
      const variant = variants.find((item) => item.available && item.options.every((optionValue, index) => optionValue === selectedOptions[index]));
      optionGroups.forEach((buttons, optionIndex) => {
        buttons.forEach((button) => {
          const value = button.dataset.optionValue;
          const possible = variants.some((item) => item.available
            && item.options[optionIndex] === value
            && item.options.slice(0, optionIndex).every((optionValue, index) => optionValue === selectedOptions[index]));
          const selected = value === selectedOptions[optionIndex];
          button.disabled = !possible;
          button.classList.toggle('is-selected', selected);
          button.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });
      });
      addButton.disabled = !variant;
      variantInput.value = variant ? String(variant.id) : '';
      addButton.textContent = variant
        ? `${tr('add_to_bag', 'AÑADIR A LA BOLSA').toUpperCase()} — ${formatMoney(variant.price)}`
        : tr('combination_sold_out', 'COMBINACIÓN AGOTADA').toUpperCase();
    }

    updateQuickAdd();
  };

  const wishlistDrawer = document.querySelector('[data-wishlist-drawer]');
  const wishlistItems = wishlistDrawer?.querySelector('[data-wishlist-items]');
  const wishlistEmpty = wishlistDrawer?.querySelector('[data-wishlist-empty]');
  const wishlistLists = wishlistDrawer?.querySelector('[data-wishlist-lists]');
  const wishlistManager = wishlistDrawer?.querySelector('[data-wishlist-manager]');
  const wishlistFooter = wishlistDrawer?.querySelector('[data-wishlist-footer]');
  const wishlistShared = wishlistDrawer?.querySelector('[data-wishlist-shared]');
  const wishlistSharedTitle = wishlistDrawer?.querySelector('[data-wishlist-shared-title]');
  const wishlistStorageKey = 'manila:wishlists:v1';
  let wishlistReturnFocus;
  let wishlistSharedMode = false;

  const createWishlistState = () => {
    const id = `list-${Date.now()}`;
    return { version: 1, activeId: id, lists: [{ id, name: tr('wishlist_default', 'Favoritos'), items: [] }] };
  };

  const loadWishlistState = () => {
    try {
      const stored = JSON.parse(window.localStorage.getItem(wishlistStorageKey));
      if (!stored || !Array.isArray(stored.lists)) return createWishlistState();
      stored.lists = stored.lists.filter((list) => list?.id && list?.name && Array.isArray(list.items));
      if (!stored.lists.length) return createWishlistState();
      if (!stored.lists.some((list) => list.id === stored.activeId)) stored.activeId = stored.lists[0].id;
      return stored;
    } catch (error) {
      return createWishlistState();
    }
  };

  let wishlistState = loadWishlistState();
  const activeWishlist = () => wishlistState.lists.find((list) => list.id === wishlistState.activeId) || wishlistState.lists[0];
  const allWishlistProductIds = () => new Set(wishlistState.lists.flatMap((list) => list.items.map((item) => String(item.id))));

  const persistWishlist = () => {
    try { window.localStorage.setItem(wishlistStorageKey, JSON.stringify(wishlistState)); } catch (error) { /* Storage can be unavailable in private contexts. */ }
  };

  refreshWishlistButtons = () => {
    const savedIds = allWishlistProductIds();
    document.querySelectorAll('[data-wishlist-product]').forEach((button) => {
      const saved = savedIds.has(String(button.dataset.productId));
      button.classList.toggle('is-selected', saved);
      button.setAttribute('aria-pressed', saved ? 'true' : 'false');
      button.setAttribute('aria-label', saved
        ? `${tr('wishlist_added_label', 'Añadido a tu wishlist')}: ${button.dataset.productTitle || ''}`.trim()
        : `${tr('wishlist_add_label', 'Añadir a mi wishlist')}: ${button.dataset.productTitle || ''}`.trim());
      const label = button.querySelector('[data-wishlist-label]');
      if (label) label.textContent = saved
        ? tr('wishlist_added_label', 'Añadido a tu wishlist')
        : tr('wishlist_add_label', 'Añadir a mi wishlist');
    });
    const count = savedIds.size;
    document.querySelectorAll('[data-wishlist-count]').forEach((element) => { element.textContent = String(count); });
  };

  const productFromButton = (button) => ({
    id: String(button.dataset.productId),
    handle: button.dataset.productHandle || '',
    url: button.dataset.productUrl || '#',
    title: button.dataset.productTitle || '',
    vendor: button.dataset.productVendor || '',
    image: button.dataset.productImage || '',
    price: Number(button.dataset.wishlistPrice || 0)
  });

  const buildWishlistItem = (item, shared = false) => {
    const article = document.createElement('article');
    article.className = 'manila-wishlist-item';
    article.dataset.wishlistItemId = String(item.id);

    const imageLink = document.createElement('a');
    imageLink.className = 'manila-wishlist-item__image';
    imageLink.href = item.url || '#';
    if (item.image) {
      const image = document.createElement('img');
      image.src = item.image;
      image.alt = '';
      image.loading = 'lazy';
      imageLink.append(image);
    }

    const info = document.createElement('div');
    info.className = 'manila-wishlist-item__info';
    const vendor = document.createElement('small');
    vendor.textContent = item.vendor || '';
    const title = document.createElement('a');
    title.href = item.url || '#';
    title.textContent = item.title || '';
    const price = document.createElement('span');
    price.textContent = formatMoney(item.price || 0);
    info.append(vendor, title, price);

    const actions = document.createElement('div');
    actions.className = 'manila-wishlist-item__actions';
    const quickAdd = document.createElement('button');
    quickAdd.type = 'button';
    quickAdd.dataset.quickAddOpen = '';
    quickAdd.dataset.productJsonUrl = `${document.body.dataset.rootUrl || '/'}products/${encodeURIComponent(item.handle)}.js`;
    quickAdd.dataset.productTitle = item.title || '';
    quickAdd.dataset.productVendor = item.vendor || '';
    quickAdd.textContent = `${tr('wishlist_add_to_bag', 'Elegir opciones')} +`;
    actions.append(quickAdd);

    if (!shared) {
      const remove = document.createElement('button');
      remove.type = 'button';
      remove.dataset.wishlistRemove = String(item.id);
      remove.textContent = tr('wishlist_remove_item', 'Eliminar');
      actions.append(remove);
      if (wishlistState.lists.length > 1) {
        const move = document.createElement('select');
        move.dataset.wishlistMove = String(item.id);
        move.setAttribute('aria-label', tr('wishlist_your_lists', 'Tus listas'));
        wishlistState.lists.forEach((list) => {
          const option = document.createElement('option');
          option.value = list.id;
          option.textContent = list.name;
          option.selected = list.id === wishlistState.activeId;
          move.append(option);
        });
        actions.append(move);
      }
    }
    info.append(actions);
    article.append(imageLink, info);
    return article;
  };

  const renderWishlist = () => {
    if (!wishlistDrawer || !wishlistItems || wishlistSharedMode) return;
    const active = activeWishlist();
    wishlistLists?.replaceChildren();
    wishlistState.lists.forEach((list) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.dataset.wishlistList = list.id;
      button.classList.toggle('is-active', list.id === active.id);
      button.setAttribute('role', 'tab');
      button.setAttribute('aria-selected', list.id === active.id ? 'true' : 'false');
      button.textContent = `${list.name} (${list.items.length})`;
      wishlistLists?.append(button);
    });
    wishlistItems.replaceChildren(...active.items.map((item) => buildWishlistItem(item)));
    if (wishlistEmpty) {
      wishlistEmpty.hidden = active.items.length > 0;
      wishlistEmpty.textContent = tr('wishlist_empty', 'Todavía no hay prendas en esta lista.');
    }
    if (wishlistFooter) wishlistFooter.hidden = false;
    refreshWishlistButtons();
  };

  const setWishlistDrawer = (open, opener) => {
    if (!wishlistDrawer) return;
    wishlistDrawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.body.classList.toggle('wishlist-open', open);
    if (open) {
      if (drawer?.getAttribute('aria-hidden') === 'false') setDrawer(false);
      wishlistReturnFocus = opener || document.activeElement;
      if (!wishlistSharedMode) renderWishlist();
      window.setTimeout(() => wishlistDrawer.querySelector('.manila-wishlist__panel')?.focus(), 30);
    } else if (wishlistReturnFocus instanceof HTMLElement) {
      wishlistReturnFocus.focus();
    }
  };

  document.querySelectorAll('[data-wishlist-open]').forEach((button) => button.addEventListener('click', () => setWishlistDrawer(true, button)));
  wishlistDrawer?.querySelectorAll('[data-wishlist-close]').forEach((button) => button.addEventListener('click', () => setWishlistDrawer(false)));
  wishlistDrawer?.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') setWishlistDrawer(false);
    trapFocus(event, wishlistDrawer);
  });

  document.addEventListener('click', (event) => {
    const productButton = event.target.closest('[data-wishlist-product]');
    if (productButton) {
      event.preventDefault();
      const product = productFromButton(productButton);
      const existingList = wishlistState.lists.find((list) => list.items.some((item) => String(item.id) === product.id));
      if (existingList) {
        existingList.items = existingList.items.filter((item) => String(item.id) !== product.id);
      } else {
        activeWishlist().items.unshift(product);
      }
      persistWishlist();
      renderWishlist();
      return;
    }

    const listButton = event.target.closest('[data-wishlist-list]');
    if (listButton) {
      wishlistState.activeId = listButton.dataset.wishlistList;
      persistWishlist();
      renderWishlist();
      return;
    }

    const removeButton = event.target.closest('[data-wishlist-remove]');
    if (removeButton) {
      const active = activeWishlist();
      if (!active) return;
      active.items = active.items.filter((item) => String(item.id) !== removeButton.dataset.wishlistRemove);
      persistWishlist();
      renderWishlist();
    }
  });

  wishlistItems?.addEventListener('change', (event) => {
    const select = event.target.closest('[data-wishlist-move]');
    if (!select || select.value === wishlistState.activeId) return;
    const source = activeWishlist();
    if (!source) return;
    const item = source.items.find((entry) => String(entry.id) === select.dataset.wishlistMove);
    const destination = wishlistState.lists.find((list) => list.id === select.value);
    if (!item || !destination) return;
    source.items = source.items.filter((entry) => String(entry.id) !== String(item.id));
    destination.items = destination.items.filter((entry) => String(entry.id) !== String(item.id));
    destination.items.unshift(item);
    wishlistState.activeId = destination.id;
    persistWishlist();
    renderWishlist();
  });

  wishlistDrawer?.querySelector('[data-wishlist-new-form]')?.addEventListener('submit', (event) => {
    event.preventDefault();
    const input = event.currentTarget.querySelector('[data-wishlist-new-name]');
    const name = input?.value.trim();
    if (!name) return;
    const id = `list-${Date.now()}`;
    wishlistState.lists.push({ id, name: name.slice(0, 40), items: [] });
    wishlistState.activeId = id;
    input.value = '';
    persistWishlist();
    renderWishlist();
  });

  const encodeWishlist = (value) => {
    const bytes = new TextEncoder().encode(JSON.stringify(value));
    let binary = '';
    bytes.forEach((byte) => { binary += String.fromCharCode(byte); });
    return window.btoa(binary).replaceAll('+', '-').replaceAll('/', '_').replaceAll('=', '');
  };
  const decodeWishlist = (value) => {
    const base64 = value.replaceAll('-', '+').replaceAll('_', '/');
    const binary = window.atob(base64.padEnd(Math.ceil(base64.length / 4) * 4, '='));
    return JSON.parse(new TextDecoder().decode(Uint8Array.from(binary, (character) => character.charCodeAt(0))));
  };

  wishlistDrawer?.querySelector('[data-wishlist-share]')?.addEventListener('click', async () => {
    const active = activeWishlist();
    if (!active) return;
    const url = new URL(document.body.dataset.rootUrl || '/', window.location.origin);
    url.searchParams.set('manila_wishlist', encodeWishlist({ name: active.name, handles: active.items.map((item) => item.handle).filter(Boolean) }));
    try {
      await navigator.clipboard.writeText(url.toString());
      showCartMessage(tr('wishlist_copied', 'Enlace público copiado'));
    } catch (error) {
      window.prompt(tr('wishlist_copy_error', 'Copia este enlace'), url.toString());
    }
  });

  wishlistDrawer?.querySelector('[data-wishlist-delete]')?.addEventListener('click', () => {
    if (!window.confirm(tr('wishlist_delete_confirm', '¿Quieres eliminar esta lista?'))) return;
    const active = activeWishlist();
    if (!active) return;
    if (wishlistState.lists.length === 1) active.items = [];
    else wishlistState.lists = wishlistState.lists.filter((list) => list.id !== active.id);
    wishlistState.activeId = wishlistState.lists[0].id;
    persistWishlist();
    renderWishlist();
  });

  const sharedToken = new URL(window.location.href).searchParams.get('manila_wishlist');
  if (sharedToken && wishlistDrawer && wishlistItems) {
    wishlistSharedMode = true;
    wishlistManager?.setAttribute('hidden', '');
    wishlistFooter?.setAttribute('hidden', '');
    wishlistShared?.removeAttribute('hidden');
    wishlistItems.replaceChildren();
    if (wishlistEmpty) {
      wishlistEmpty.hidden = false;
      wishlistEmpty.textContent = tr('wishlist_loading', 'Cargando selección…');
    }
    try {
      const sharedData = decodeWishlist(sharedToken);
      if (!Array.isArray(sharedData.handles)) throw new Error('Invalid wishlist');
      if (wishlistSharedTitle) wishlistSharedTitle.textContent = sharedData.name || tr('wishlist_shared', 'Selección compartida');
      Promise.all(sharedData.handles.map(async (handle) => {
        const response = await fetch(`${document.body.dataset.rootUrl || '/'}products/${encodeURIComponent(handle)}.js`, { headers: { Accept: 'application/json' } });
        if (!response.ok) return null;
        const product = await response.json();
        const featuredImage = typeof product.featured_image === 'string' ? product.featured_image : product.featured_image?.src;
        return { id: String(product.id), handle: product.handle, url: product.url, title: product.title, vendor: product.vendor, image: featuredImage || '', price: product.price };
      })).then((items) => {
        const validItems = items.filter(Boolean);
        wishlistItems.replaceChildren(...validItems.map((item) => buildWishlistItem(item, true)));
        if (wishlistEmpty) {
          wishlistEmpty.hidden = validItems.length > 0;
          wishlistEmpty.textContent = tr('wishlist_empty', 'Todavía no hay prendas en esta lista.');
        }
      });
      setWishlistDrawer(true);
    } catch (error) {
      if (wishlistEmpty) wishlistEmpty.textContent = tr('wishlist_invalid', 'Este enlace de wishlist no es válido.');
      setWishlistDrawer(true);
    }
  }

  renderWishlist();
  refreshWishlistButtons();

  document.addEventListener('click', async (event) => {
    const trigger = event.target.closest('[data-quick-add-open]');
    if (!trigger || !quickAddSheet || !quickAddContent) return;
    quickAddReturnFocus = trigger;
    quickAddFromCart = Boolean(trigger.closest('[data-cart-cross-sell]'));
    setSheet(quickAddSheet, true);
    quickAddContent.replaceChildren();
    const loading = document.createElement('p');
    loading.className = 'manila-quick-add__loading';
    loading.textContent = tr('loading_options', 'Cargando opciones…');
    quickAddContent.append(loading);
    try {
      const productUrl = trigger.dataset.productJsonUrl;
      let productData = quickAddCache.get(productUrl);
      if (!productData) {
        const response = await fetch(productUrl, { headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error('No se pudieron cargar las opciones');
        productData = await response.json();
        quickAddCache.set(productUrl, productData);
      }
      renderQuickAdd(productData, trigger);
    } catch (error) {
      quickAddContent.replaceChildren();
      const message = document.createElement('p');
      message.className = 'manila-quick-add__error';
      message.textContent = tr('options_error', 'No hemos podido cargar las opciones. Abre el producto para elegir la talla.');
      quickAddContent.append(message);
    }
  });

  document.querySelectorAll('[data-size-guide-sheet]').forEach((sheet) => {
    let returnFocus;
    document.querySelectorAll('[data-size-guide-open]').forEach((trigger) => {
      trigger.addEventListener('click', () => {
        returnFocus = trigger;
        setSheet(sheet, true);
      });
    });
    const close = () => setSheet(sheet, false, returnFocus);
    sheet.querySelectorAll('[data-size-guide-close]').forEach((button) => button.addEventListener('click', close));
    sheet.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') close();
      trapFocus(event, sheet);
    });
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.action.includes('/cart/add')) return;
    event.preventDefault();
    const submitButton = event.submitter || form.querySelector('button[type="submit"]');
    const originalText = submitButton?.textContent;
    const reloadCart = Boolean(form.closest('[data-cart-cross-sell]')) || (quickAddFromCart && Boolean(form.closest('[data-quick-add-content]')));
    if (submitButton) {
      submitButton.disabled = true;
      submitButton.textContent = tr('adding', 'AÑADIENDO…').toUpperCase();
    }
    try {
      const cartAddUrl = document.body.dataset.cartAddUrl || '/cart/add';
      const response = await fetch(cartAddUrl.endsWith('.js') ? cartAddUrl : `${cartAddUrl}.js`, {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: new FormData(form)
      });
      const payload = await response.json();
      if (!response.ok) throw new Error(payload.description || tr('add_error', 'No se ha podido añadir el producto.'));
      await updateCartCount();
      showCartMessage(tr('added', 'AÑADIDO A LA BOLSA').toUpperCase());
      if (form.closest('[data-quick-add-content]')) closeQuickAdd();
      if (reloadCart) window.setTimeout(() => window.location.reload(), 500);
    } catch (error) {
      showCartMessage(error.message || tr('add_error', 'No se ha podido añadir el producto.'), true);
    } finally {
      if (submitButton) {
        submitButton.disabled = false;
        submitButton.textContent = originalText;
      }
    }
  });

  document.querySelectorAll('.manila-quantity__control').forEach((control) => {
    const input = control.querySelector('input[type="number"]');
    const minus = control.querySelector('[data-quantity-minus]');
    const plus = control.querySelector('[data-quantity-plus]');
    if (!input) return;
    minus?.addEventListener('click', () => {
      const minimum = Number(input.min || 1);
      input.value = String(Math.max(minimum, Number(input.value || minimum) - 1));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    plus?.addEventListener('click', () => {
      const maximum = input.max ? Number(input.max) : Infinity;
      input.value = String(Math.min(maximum, Number(input.value || 0) + 1));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });
});
